import React from 'react'
import PageHeaderActions from '../../../layout/PageHeaderActions'
import OcDashboard from '../components/OcDashboard'
import ClientHeader from '../../../components/ClientHeader/ClientHeader'
import OcErrorStatus from '../components/OcErrorStatus'
import OcNotInsertedStatus from '../components/OcNotInsertedStatus'
import { OC_CLIENT_HEADER_CONFIG, OC_STATUS_KEYS } from '../constants/ocConstants'

const OcTabLayout = ({
  title,
  actions,
  children,
  summary,
  tabsOrders,
  isError = false,
  purchaseOrder,
  last_activity_at,
  errordetails,
  status,
  insertionErrorDetails
}) => {
  const showNotInsertedBanner = status === OC_STATUS_KEYS.NO_INSERTED

  return (
    <>
      <PageHeaderActions
        title={title}
        actions={actions}
      />

      {showNotInsertedBanner && (
        <OcNotInsertedStatus details={insertionErrorDetails} />
      )}

      {!isError && (
        <>
          <hr />
          <OcDashboard
            summary={summary}
            tabsOrders={tabsOrders}
            last_activity_at={last_activity_at}
          />
        </>
      )}

      {isError && (
        <>
          <hr />
          <ClientHeader
            data={purchaseOrder}
            config={OC_CLIENT_HEADER_CONFIG.error}
          />

          <OcErrorStatus details={errordetails} />
        </>
      )}

      <hr />

      {children}
    </>
  )
}

export default OcTabLayout
